import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import MobileTab from './Tab';
import { useLocation } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { LISTURL } from '../config';
import clsx from 'clsx';

const Dashboard = (): JSX.Element => {
  const [isSettingPage, setIsSettingPage] = useImmer<boolean>(false);
  const { pathname } = useLocation();
  useEffect(() => {
    if (LISTURL.settings === pathname) {
      setIsSettingPage(true);
    } else {
      setIsSettingPage(false);
    }
  }, [pathname]);
  return (
    <div className="flex flex-wrap">
      <div
        className={clsx(
          isSettingPage ? 'navigation-relative' : null,
          'navigation fixed top-0 left-0 bottom-0 z-[99] hidden lg:block',
        )}
      >
        <Navigation />
      </div>
      <div
        className={clsx(
          isSettingPage ? 'main-content-relative' : null,
          'main-content min-h-screen flex flex-col justify-between',
        )}
      >
        <Outlet />
        <Footer />
        <MobileTab />
      </div>
    </div>
  );
};

export default Dashboard;
